import { createGlobalStyle } from 'styled-components';
import { color, font } from './styles/tokens';

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    /* iOS Safari tints its address bar from the page background, so the canvas
       has to be the dark ink — every section paints its own colour on top. */
    background-color: ${color.ink};
  }

  body {
    font-family: ${font.body};
    font-weight: 400;
    font-size: 16px;
    line-height: 1.6;
    color: ${color.text};
    background-color: ${color.ink};
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
  }

  h1, h2, h3 {
    font-family: ${font.display};
    font-weight: 300;
    line-height: 1.05;
    text-wrap: balance;
  }

  p {
    text-wrap: pretty;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img, svg, iframe {
    display: block;
    max-width: 100%;
  }

  ul {
    list-style: none;
  }

  :focus-visible {
    outline: 2px solid ${color.fuchsia};
    outline-offset: 3px;
    border-radius: 2px;
  }

  ::selection {
    background: ${color.roseSoft};
    color: ${color.ink};
  }

  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }

    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;

export default GlobalStyles;
